import React, {useCallback, useEffect, useState} from 'react';
import {
    Flame,
    Trees,
    Wifi,
    Coffee,
    Tv,
    Car,
    Users,
    MapPin,
    Image,
    Menu,
    X,
    Heart, ArrowRight, Check, Send, CheckCircle2
} from 'lucide-react';
import {Link, useLocation} from 'react-router-dom';
import {IMaskInput} from "react-imask/esm";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

export default function RentHouse() {

    const now = new Date();

    // Форматування поточної дати та часу
    const formattedDate = new Intl.DateTimeFormat('uk-UA', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour12: false // 24-годинний формат
    })
        .format(now)
        .replace(',', '');

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Колірна гама:
    // - Dark Olive/Forest: #1A261D
    // - Warm Wood / Ochre: #C88A58
    // - Deep Charcoal: #121614
    // - Soft Amber Accent: #E07A5F

    const location = useLocation();

    // order send
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formData, setFormData] = useState({name: '', phone: '', date: '', message: ''});
    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleFormSubmit = useCallback( async (e) => {

        e.preventDefault();

        if (!executeRecaptcha) {
            console.error('reCAPTCHA ще не завантажилася');
            return;
        }

        const token = await executeRecaptcha('rent_house');

        if (!token) {
            console.error('Не вдалося отримати токен reCAPTCHA');
            return;
        }

        const formData = new FormData(e.target);

        const name = formData.get('name');
        const phone = formData.get('phone');
        const date = formData.get('date');
        const note = formData.get('note');
        const message = `<b>Бронювання будинку - на ${date}</b>
                            👤 <b>Ім'я:</b> ${name}
                            📞 <b>Телефон:</b> ${phone}
                            📅 <b>Дата:</b> ${date}
                            🗒️ <b>Гостей:</b> ${note}`;

        formData.append('text', message);
        // formData.append('recaptchaToken', token);
        // formData.append('parse_mode', 'HTML');

        try {

            const response = await fetch('https://myoffice.cv/sending/telegram.php', {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.ok) {
                localStorage.setItem('form_submitted', 'true');
                // setFormSubmitted(true);
                // window.location.reload();
            } else {
                alert('Помилка: ' + result.message);
            }
        } catch (error) {
            console.error('Помилка відправки:', error);
        }

        setFormSubmitted(true);
        localStorage.setItem('form_submitted', 'true');

        setTimeout(() => {
            // setFormSubmitted(false);
            // localStorage.setItem('form_submitted', 'true');
            setFormData({name: '', phone: '', date: '', message: ''});
        }, 2500);
    }, [executeRecaptcha]);

    useEffect(() => {

        const status = localStorage.getItem('form_submitted');
        if (status === 'true') {
            setFormSubmitted(true);
        }

        // Отримуємо хеш з адреси (наприклад, "#about")
        const hash = window.location.hash.split('#')[2];
        if (hash) {
            const element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
            }
        }
    }, [location]);

    return (
        <div
            className="min-h-screen bg-[#121614] text-[#EBE8E1] font-sans antialiased selection:bg-[#C88A58] selection:text-white">

            {/* Навігація */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-[#121614]/80 backdrop-blur-md border-b border-[#2A342D]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
                    <Link to="/rent-house"
                          className="flex items-center gap-2 text-xl font-serif tracking-wider text-[#EBE8E1]">
                        <Trees className="w-6 h-6 text-[#C88A58]"/>
                        <span className="font-bold">HLUSHMAN</span> HOUSE
                    </Link>

                    {/* Десктоп Меню */}
                    <div className="hidden md:flex items-center gap-8 text-sm font-medium">
                        <Link to="/rent-house#about" className="hover:text-[#C88A58] transition-colors">Про
                            будинок</Link>
                        <Link to="/rent-house#chan" className="hover:text-[#C88A58] transition-colors">Чан на
                            дровах</Link>
                        <Link to="/rent-house#amenities"
                              className="hover:text-[#C88A58] transition-colors">Зручності</Link>
                        <Link to="/rent-house#gallery" className="hover:text-[#C88A58] transition-colors">Галерея</Link>
                        <Link to="/rent-house#location"
                              className="hover:text-[#C88A58] transition-colors">Локація</Link>
                    </div>

                    <div className="hidden md:flex items-center gap-4">
                        <Link
                            to="https://www.instagram.com/hlushman_house/"
                            target="_blank"
                            rel="noreferrer"
                            className="p-2 bg-[#1A261D] rounded-full hover:bg-[#C88A58] transition-colors text-white"
                        >
                            <Image className="w-5 h-5"/>
                        </Link>
                        <Link
                            to="/rent-house/#booking"
                            className="px-5 py-2.5 bg-[#C88A58] hover:bg-[#B07545] text-white font-medium rounded-lg transition-all shadow-lg shadow-[#C88A58]/20"
                        >
                            Забронювати
                        </Link>
                    </div>

                    {/* Мобільна кнопка */}
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="md:hidden p-2 text-gray-300 hover:text-white"
                    >
                        {isMenuOpen ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
                    </button>
                </div>

                {/* Мобільне меню */}
                {isMenuOpen && (
                    <div className="md:hidden bg-[#1A261D] border-b border-[#2A342D] px-4 pt-2 pb-6 space-y-4">
                        <Link to="/rent-house#about" onClick={() => setIsMenuOpen(false)}
                              className="block py-2 text-lg">Про будинок</Link>
                        <Link to="/rent-house#chan" onClick={() => setIsMenuOpen(false)} className="block py-2 text-lg">Чан
                            на дровах</Link>
                        <Link to="/rent-house#amenities" onClick={() => setIsMenuOpen(false)}
                              className="block py-2 text-lg">Зручності</Link>
                        <Link to="/rent-house#gallery" onClick={() => setIsMenuOpen(false)}
                              className="block py-2 text-lg">Галерея</Link>
                        <Link to="/rent-house#location" onClick={() => setIsMenuOpen(false)}
                              className="block py-2 text-lg">Локація</Link>
                        <Link
                            to="https://www.instagram.com/hlushman_house/"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 py-2 text-[#C88A58]"
                        >
                            <Image className="w-5 h-5"/> Інстаграм
                        </Link>
                    </div>
                )}
            </nav>

            {/* Hero Section */}
            <section className="relative h-screen flex items-center justify-center pt-20 overflow-hidden">
                {/* Фоновe зображення з градієнтом */}
                <div className="absolute inset-0 z-0">
                    <img
                        src="https://images.unsplash.com/photo-1542718610-a1d656d1884c?auto=format&fit=crop&w=1920&q=80"
                        alt="Hlushman House у Карпатах"
                        className="w-full h-full object-cover object-center scale-105 animate-pulse transition-all duration-10000"
                        style={{animationDuration: '20s'}}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#121614] via-[#121614]/60 to-[#121614]/30"/>
                </div>

                <div className="relative z-10 text-center max-w-4xl mx-auto px-4 sm:px-6">
          <span
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1A261D]/80 border border-[#C88A58]/40 text-[#C88A58] text-sm font-medium mb-6 backdrop-blur-sm">
            <MapPin className="w-4 h-4"/> смт. Ясіня, Карпати
          </span>
                    <h1 className="text-4xl sm:text-6xl md:text-7xl font-serif font-bold text-white tracking-tight leading-tight mb-6">
                        Затишний відпочинок та карпатський чан
                    </h1>
                    <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-10 font-light">
                        Втечіть від міської метушні у серце Карпат. Затишний деревяний будинок, панорамний вид на гори
                        та релакс у гарячому чані.
                    </p>

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <Link
                            to="/rent-house#booking"
                            className="w-full sm:w-auto px-8 py-4 bg-[#C88A58] hover:bg-[#B07545] text-white font-semibold rounded-lg shadow-xl shadow-[#C88A58]/20 transition-all transform hover:-translate-y-0.5"
                        >
                            Забронювати відпочинок
                        </Link>
                        <Link
                            to="/rent-house#chan"
                            className="w-full sm:w-auto px-8 py-4 bg-[#1A261D]/90 hover:bg-[#253629] border border-[#2A342D] text-white font-semibold rounded-lg backdrop-blur-sm transition-all flex items-center justify-center gap-2"
                        >
                            <Flame className="w-5 h-5 text-[#E07A5F]"/> Відпочинок у чані
                        </Link>
                    </div>
                </div>

                {/* Стрілка вниз */}
                <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
                    <Link to="#about" className="text-gray-400 hover:text-white">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7-7-7"/>
                        </svg>
                    </Link>
                </div>
            </section>

            {/* Про будинок */}
            <section id="about" className="py-24 bg-[#121614] border-b border-[#1A261D]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div className="space-y-6">
                            <span className="text-[#C88A58] font-semibold uppercase tracking-wider text-sm">Ласкаво просимо</span>
                            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white">
                                Ваш ідеальний дім серед карпатських вершин
                            </h2>
                            <p className="text-gray-300 leading-relaxed">
                                <strong>Hlushman House</strong> — це атмосферний котедж у селищі Ясіня, розташований
                                неподалік від популярних гірськолижних курортів Буковель та Драгобрат.
                            </p>
                            <p className="text-gray-400 leading-relaxed">
                                Тут поєднується традиційний карпатський затишок з сучасним комфортом. Наш будинок чудово
                                підійде як для сімейного відпочинку, так і для компанії друзів, які прагнуть
                                перезавантаження на природі.
                            </p>

                            <div className="grid grid-cols-2 gap-4 pt-4">
                                <div
                                    className="flex items-center gap-3 p-3 rounded-lg bg-[#1A261D]/50 border border-[#2A342D]">
                                    <Users className="w-6 h-6 text-[#C88A58]"/>
                                    <div>
                                        <p className="text-sm font-semibold text-white">Місткість</p>
                                        <p className="text-xs text-gray-400">до 10-12 гостей</p>
                                    </div>
                                </div>
                                <div
                                    className="flex items-center gap-3 p-3 rounded-lg bg-[#1A261D]/50 border border-[#2A342D]">
                                    <MapPin className="w-6 h-6 text-[#C88A58]"/>
                                    <div>
                                        <p className="text-sm font-semibold text-white">Локація</p>
                                        <p className="text-xs text-gray-400">смт. Ясіня</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="aspect-4/3 rounded-2xl overflow-hidden shadow-2xl border border-[#2A342D]">
                                <img
                                    src="/img/rent/4.png"
                                    alt="Інтер'єр Hlushman House"
                                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                                />
                            </div>
                            <div
                                className="absolute -bottom-6 -left-6 bg-[#1A261D] p-6 rounded-xl border border-[#2A342D] shadow-xl hidden sm:block">
                                <p className="text-2xl font-serif font-bold text-[#C88A58]">100%</p>
                                <p className="text-xs text-gray-300">Затишку та релаксу</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Окремий блок: Чан на дровах */}
            <section id="chan" className="py-24 bg-[#1A261D] relative overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div className="order-2 md:order-1 relative">
                            <div
                                className="aspect-square rounded-2xl overflow-hidden shadow-2xl border border-[#C88A58]/30">
                                <img
                                    src="/img/rent/2.png"
                                    alt="Карпатський Чан"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="absolute top-4 right-4 bg-[#E07A5F] text-white p-3 rounded-full shadow-lg">
                                <Flame className="w-6 h-6 animate-pulse"/>
                            </div>
                        </div>

                        <div className="order-1 md:order-2 space-y-6">
              <span className="text-[#E07A5F] font-semibold uppercase tracking-wider text-sm flex items-center gap-2">
                <Flame className="w-4 h-4"/> Особливий релакс
              </span>
                            <h2 className="text-3xl sm:text-5xl font-serif font-bold text-white">
                                Традиційний карпатський чан під відкритим небом
                            </h2>
                            <p className="text-gray-300 leading-relaxed">
                                Відновіть сили після насиченого дня в горах у нашому чані на дровах. Гаряча вода з
                                запашними гірськими травами, свіже карпатське повітря та неймовірні краєвиди навколо.
                            </p>

                            <ul className="space-y-3">
                                {[
                                    'Купання на свіжому повітрі в будь-яку пору року',
                                    'Оздоровлення та зняття втоми у м’язах',
                                    'Натуральні карпатські трави та ароматерапія',
                                    'Зона відпочинку поруч із чаном'
                                ].map((item, idx) => (
                                    <li key={idx} className="flex items-center gap-3 text-gray-200">
                                        <ArrowRight className="w-5 h-5 text-[#C88A58] shrink-0"/>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Зручності */}
            <section id="amenities" className="py-24 bg-[#121614]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-4">
                            Усе для вашого комфорту
                        </h2>
                        <p className="text-gray-400">
                            Ми подбали про кожну деталь, щоб ви почувалися як дома.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {[
                            {icon: Flame, title: 'Чан на дровах', desc: 'Просто неба'},
                            {icon: Trees, title: 'Альтанка та мангал', desc: 'Для смачних вечорів'},
                            {icon: Wifi, title: 'Швидкісний Wi-Fi', desc: 'Безперебійний зв’язок'},
                            {icon: Coffee, title: 'Обладнана кухня', desc: 'Техніка та посуд'},
                            {icon: Tv, title: 'Smart TV', desc: 'Для затишних кіновечорів'},
                            {icon: Car, title: 'Парковка', desc: 'На території будинку'},
                            {icon: Users, title: 'Просторі номери', desc: 'Зручні ліжка та білизна'},
                            {icon: Heart, title: 'Карпатська природа', desc: 'Тиша та краєвиди'},
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="p-6 bg-[#1A261D]/40 rounded-xl border border-[#2A342D] hover:border-[#C88A58]/50 transition-all hover:-translate-y-1 group"
                            >
                                <item.icon
                                    className="w-8 h-8 text-[#C88A58] mb-4 group-hover:scale-110 transition-transform"/>
                                <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                                <p className="text-xs text-gray-400">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Галерея / Instagram атмосфера */}
            <section id="gallery" className="py-24 bg-[#1A261D]/30 border-t border-[#1A261D]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
                        <div>
                            <span className="text-[#C88A58] font-semibold uppercase tracking-wider text-sm">Атмосфера Reels</span>
                            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mt-1">
                                Моменти з Hlushman House
                            </h2>
                        </div>
                        <Link
                            to="https://www.instagram.com/hlushman_house/"
                            target="_blank"
                            rel="noreferrer"
                            className="mt-4 md:mt-0 inline-flex items-center gap-2 text-[#C88A58] hover:text-[#B07545] font-medium transition-colors"
                        >
                            <Image className="w-5 h-5"/> Дивитися більше в Instagram →
                        </Link>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            {img: '/img/rent/6.jpg', title: 'Вид на гори'},
                            {img: '/img/rent/2.jpg', title: 'Карпатський чан'},
                            {img: '/img/rent/3.png', title: 'Затишна вітальня'}, //5.jpg
                            {img: '/img/rent/9.jpg', title: 'Тераса'},
                            {img: '/img/rent/7.png', title: 'Екстер’єр котеджу'},
                            {img: '/img/rent/8.png', title: 'Вечір біля чану'},
                        ].map((item, index) => (
                            <div key={index}
                                 className="group relative aspect-4/3 rounded-xl overflow-hidden bg-[#1A261D] border border-[#2A342D]">
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                />
                                <div
                                    className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                                    <p className="text-white font-medium text-lg">{item.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Бронювання та Контакти */}
            <section id="booking" className="py-24 bg-[#121614] border-t border-[#1A261D]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-[#1A261D] rounded-3xl p-8 sm:p-12 border border-[#2A342D] shadow-2xl">
                        <div className="grid md:grid-cols-2 gap-12">

                            <div>
                                <span
                                    className="text-[#C88A58] font-semibold uppercase tracking-wider text-sm">Забронювати</span>
                                <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mt-2 mb-6">
                                    Плануєте відпочинок?
                                </h2>
                                <p className="text-gray-300 mb-8 leading-relaxed">
                                    Зв’яжіться з нами напряму для перевірки вільних дат та бронювання будинку або чану.
                                    Ми з радістю відповімо на всі ваші запитання!
                                </p>

                                <div id={'location'} className="space-y-4">
                                    <div className="flex items-center gap-4 text-gray-200">
                                        <div className="p-3 bg-[#121614] rounded-lg text-[#C88A58]">
                                            <MapPin className="w-6 h-6"/>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-400">Локація</p>
                                            <p className="font-semibold">смт. Ясіня, Закарпатська обл.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-4 text-gray-200">
                                        <div className="p-3 bg-[#121614] rounded-lg text-[#C88A58]">
                                            <Image className="w-6 h-6"/>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-400">Direct / Instagram</p>
                                            <Link to="https://www.instagram.com/hlushman_house/" target="_blank"
                                                  rel="noreferrer"
                                                  className="font-semibold hover:text-[#C88A58] transition-colors">
                                                @hlushman_house
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Форма швидкого запиту */}
                            {!formSubmitted ? (
                                    <form onSubmit={handleFormSubmit}
                                          className="space-y-4 bg-[#121614] p-6 rounded-2xl border border-[#2A342D]">
                                        <h3 className="text-xl font-bold text-white mb-2">Надіслати запит</h3>
                                        <div>
                                            <label className="block text-xs text-gray-400 mb-1">Ваше ім’я</label>
                                            <input
                                                name={'name'}
                                                type="text"
                                                placeholder="Олександр"
                                                className="w-full bg-[#1A261D] border border-[#2A342D] rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:outline-none focus:border-[#C88A58]"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs text-gray-400 mb-1">Номер телефону</label>
                                            <IMaskInput
                                                mask="+380 (00) 000-00-00"
                                                type="tel"
                                                required
                                                name="phone"
                                                placeholder="+380 (68) 000-00-00"
                                                value={formData.phone}
                                                // onAccept повертає відформатоване значення при кожному вводі
                                                onAccept={(value) => setFormData({ ...formData, phone: value })}
                                                className="w-full bg-[#1A261D] border border-[#2A342D] rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:outline-none focus:border-[#C88A58]"
                                            />
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-xs text-gray-400 mb-1">Дата заїзду</label>
                                                <input
                                                    name={'date'}
                                                    type="date"
                                                    className="w-full bg-[#1A261D] border border-[#2A342D] rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-[#C88A58]"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-xs text-gray-400 mb-1">Кількість гостей</label>
                                                <input
                                                    name={'note'}
                                                    type="number"
                                                    placeholder="4"
                                                    className="w-full bg-[#1A261D] border border-[#2A342D] rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:outline-none focus:border-[#C88A58]"
                                                />
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="w-full py-3 bg-[#C88A58] hover:bg-[#B07545] text-white font-semibold rounded-lg transition-all shadow-md mt-2"
                                        >
                                            Надіслати запит
                                        </button>
                                    </form>
                                )
                                : (
                                    <div className="text-center py-8 space-y-4 border rounded-xl p-3">
                                        <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto">
                                            <CheckCircle2 size={36} />
                                        </div>
                                        <h3 className="text-2xl font-bold text-slate-100">Заявку прийнято!</h3>
                                        <p className="text-slate-100 text-sm">
                                            Дякуємо! Ми зв'яжемося з вами найближчим часом для узгодження деталей перегляду.
                                        </p>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </section>

            {/* Футер */}
            <footer className="py-8 bg-[#0C0F0D] border-t border-[#1A261D] text-center text-xs text-gray-500">
                <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p>© {new Date().getFullYear()} Hlushman House. Усі права захищені.</p>
                    <p className="flex items-center gap-1">
                        смт. Ясіня, Карпати • <Link to="https://www.instagram.com/hlushman_house/" target="_blank"
                                                    rel="noreferrer"
                                                    className="text-gray-400 hover:text-[#C88A58]">Instagram</Link>
                    </p>
                </div>
            </footer>

        </div>
    );
}